module.exports = __webpack_public_path__ + "img/ic_setting.6b7ce5f1.png";